import { render } from "./AtsDistribution.vue?vue&type=template&id=907debf4"
import script from "./AtsDistribution.vue?vue&type=script&lang=js"
export * from "./AtsDistribution.vue?vue&type=script&lang=js"
script.render = render

export default script